import Modal from "react-bootstrap/Modal";

const TermsOfService = (props) => {
  return (
    <div>
      <Modal
        size="lg"
        show={props.show}
        onHide={() => props.hideToS()}
        aria-labelledby="terms-service-popup"
      >
        <Modal.Header closeButton>
          <Modal.Title id="terms-service-popup">Terms of Service</Modal.Title>
        </Modal.Header>
        <Modal.Body className="terms-service-popup">
          <div className="row">
            <h2>Terms Of Service Agreement</h2>
            <p>
              Welcome to Vocal results and Artist development. This document is
              an agreement between you, hereafter referred to as{" "}
              <b>“you” , “student” , “students” , “client” </b>or{" "}
              <b>“clients” </b>and Vocal results & Artist development, hereafter
              referred to as <b>“us” , “Vr&Ad” or “The company”</b>. By
              submitting your payment you accept that you have read, understood
              and agree to the entirety of this agreement.
            </p>
            <br />

            <h4>Music software and audio/video training:</h4>
            <p>
              <b>The company</b> is not responsible for any harm or injury of
              any type caused by sudden or persistent practice of training,
              digital tools or any other content or consultation advice obtained
              from our platform, services or products. Practice at your own risk
              and discretion.
            </p>

            <p>
              <b>The client</b> will not temper with, copy or replicate any of
              the content, platform, marketing, software, code or any element of
              our service or products. Doing so will represent a material breach
              punishable by international copyright, intellectual property and
              patent laws. Access is limited to our authorization and any
              violation will be reported as a criminal act.
            </p>

            <p>
              <b>You</b> will not create visual or audio content using our
              software without our consent and authorization in written form. If
              you wish to create and share content using our applications or
              services please reach out to
              <a
                href="mailto:
              info@vocalresults.com"
              >
                {" "}
                info@vocalresults.com
              </a>{" "}
              prior to publication to await for explicit authorization. Vocal
              results, vocal results studio are brands of <b>The company</b> and
              any use of image represents a material breach to this agreement
            </p>

            <p>
              The onboarding call offered in the order bump may not be private
              if the volume of solicitations of the products is too high.
              <b> Instructor</b> selection and schedule selection is not
              available for this service. Our training software is based online
              at{" "}
              <a href="https://app.vocalresults.com">
                https://app.vocalresults.com
              </a>{" "}
              and does not require download.
            </p>

            <h4>Singing lessons/music instruction service:</h4>
            <ul>
              <li>
                <b>Student</b> and/or Guardian will conduct with respect and
                dignity to all instructors and staff from <b>Vr&Ad</b>. We
                reserve our right to provide our service or not to anyone at any
                time for any reason or without a reason
              </li>
              <li>
                Our prices and services may change at our discretion at any time
                for any reason or without a reason.
              </li>
              <li>
                Once you choose a schedule for your first lesson and the
                instructor confirms his/her availability for that time slot,
                your lessons will be recurring on that same day and time for
                future sessions until both parties state otherwise.
              </li>
              <li>
                Sessions have a length of 55 minutes unless stated otherwise in
                written form.
              </li>
              <li>Lessons are individual and untransferable.</li>{" "}
              <li>
                Whenever agreements with instructor and these{" "}
                <b>Terms Of Service</b>
                would conflict, <b>Terms Of Service</b> will prevail.
              </li>{" "}
              <li>
                You will schedule only your first session and allow your teacher
                to book the rest for you in the time that both of you agree
                during the time of the first session. Your sessions must take
                place at the same time and date every week.
              </li>{" "}
              <li>
                All payments must be performed through <b>Vr&Ad</b> official
                platform. Soliciting any services from any of our instructors
                outside of the platform shall be a material breach of this
                agreement and shall entitle us to any and all remedies at law or
                in equity.
              </li>{" "}
              <li>
                Lessons will not be provided until confirmation of payment has
                been received and confirmed to the instructor.
              </li>{" "}
              <li>
                You commit to test your connection, audio, and video before the
                time of your session. No time will be made up for issues
                regarding connectivity on your end.
              </li>
              <li>You will be attentive to differences between time zones.</li>
              <li>
                <b>You</b> will inform your Instructor via email if you expect
                to be late for your session and you agree that your session will
                be finished and charged as missed after 14 minutes of tardiness.
              </li>
              <li>
                Lessons have an expiration date starting at the moment of
                purchase. If the <b>student</b> wouldn’t be able to attend the
                next session he/she would have to make sure to inform us with at
                least one week of anticipation, otherwise, the session will be
                marked as missed and charged. In the case of one week in advance
                notice cancellations, the class will be moved to the following
                week without altering the consequent scheduled sessions.
                <br />
                Credits can not be redeemed after 5 weeks. It is possible to use
                more than 1 credit per week if the instructor’s availability
                allows it and it has to be communicated and accepted with at
                least one week in advance.
              </li>
              <li>
                Expiration dates are as follows: 6 weeks for “5 pack with one
                session once/ week” and for “10 pack with two sessions/ week”,
                11 weeks for “5 pack with one session every other week”
              </li>
              <li>
                Singing and music practice may cause temporary and permanent
                damage by sudden or consistent practice. The <b>student</b> or
                guardian is responsible at all times to practice at his/her own
                risk and discretion even when instructed by the teacher.
              </li>
              <li>
                <b>You</b> will stay alert of email notifications and other
                forms of communication from us which may include but are not
                limited to reminders, follow ups and confirmations. You will not
                unsubscribe from our communication for the time you are using
                our services and will inform us immediately if our communication
                would stop at any moment.
              </li>
              <li>
                <b>You</b> will inform us if your session was mistakenly charged
                by your instructor within 48 hours of follow up email emission.
              </li>
              <li>
                Underage students must be supervised by parents at all times. In
                case contrary the session may be canceled at the instructor's
                discretion and will be marked as attended and charged.
              </li>
              <li>
                Romantic and sexual relationships are not allowed between
                <b>instructor</b> and student or guardian.
              </li>
              <li>
                You will immediately report any misbehavior of any type from
                instructors
              </li>
              <li>
                You will keep all communication with your instructor through our
                official email addresses with domain @vocalresults.com
              </li>
              <li>
                You will not offer or solicit any type of products or services
                to your instructor.
              </li>
              <li>
                Nor <b>Vr&Ad</b> or any affiliated instructors are responsible
                for any physical or moral damages caused during sessions or out
                of them due or not to the instructions of Instructor.
              </li>
              <li>
                Invitation to the group showcase will only be possible to
                currently active <b>students</b>.
              </li>
              <li>
                In any case, <b>Vr&Ad</b> is not responsible for any damage or
                crime that could arise from the relationship between{" "}
                <b>student</b> and instructor.
              </li>
              <li>
                The <b>student</b> may be verbally asked if he/she can be video
                and/or audio recorded or photographed. In the case of verbal
                consent by the student or guardian, this material may be used
                publicly for promotional and commercial purposes. Please provide
                a written statement to be accepted and signed by the instructor
                indicating that the <b>student</b> doesn’t want his/her
                recordings to be shared publicly.
              </li>
              <li>
                Sessions are charged at the time of the beginning of the
                scheduled session. Refunds will only be possible if any
                instructor is not able to deliver the service in the schedule
                specified in the calendar and agreed by both parties and the
                person in charge of payment will be reimbursed only for lessons
                not yet attended and excluding transaction fees.
              </li>
              <li>
                The session will be ended and charged at the instructor’s
                discretion if he/she suspects that the student or guardian may
                be intoxicated, under the influence of drugs or alcohol, acting
                aggressive or confrontational.
              </li>
            </ul>

            <h4>Group events:</h4>
            <p>
              Group events take place every three or four months based on{" "}
              <b>The company</b>’s discretion.
            </p>
            <p>
              {" "}
              Group events are recorded and their content may be edited and used
              for promotional and commercial purposes without limitation of time
              or form, without any further notice and/or financial earnings owed
              to the parts involved for the use of their image.
            </p>
            <p>
              {" "}
              If you don’t agree with these <b>Terms Of Service</b> please do
              not use our services or products.
            </p>
            <p>
              All these considerations allow us to provide a transparent and
              long-lasting service to thrive in the development of your music
              and singing practice.
            </p>
            <p>Thank you in advance for your understanding</p>

            <h6 style={{ marginTop: "5em" }}>Vr&Ad Team</h6>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TermsOfService;
